import React from "react";

export const DASHBOARD_HELP_TITLE = "Painel";

export function DashboardHelpContent() {
  return (
    <>
      <p>
        <strong>Para que serve?</strong> Esta é a página inicial da fazenda — a
        visão central de tudo que acontece no campo e no escritório. Aqui você
        acompanha máquinas, operações, deslocamentos e comunicação com a equipe
        em um só lugar.
      </p>
      <p>
        <strong>Indicadores no topo:</strong>
      </p>
      <ul>
        <li>
          <strong>Operações</strong> — quantas estão em andamento, pendentes ou
          agendadas. Clique para ver a lista e abrir cada operação.
        </li>
        <li>
          <strong>Máquinas</strong> — quantas estão ligadas e o total cadastrado
          na fazenda. Clique para listar todas.
        </li>
        <li>
          <strong>Relatórios</strong> — esta tela antiga ainda não tem dados.
          O clique abre as operações, que é onde o trabalho aparece.
        </li>
        <li>
          <strong>Ociosidade</strong> — percentual e tempo ocioso no período
          selecionado.
        </li>
      </ul>
      <p>
        <strong>Mapa — máquinas e deslocamento:</strong>
      </p>
      <ul>
        <li>
          Todas as <strong>máquinas cadastradas</strong> na fazenda aparecem no
          mapa ao mesmo tempo, com posição atualizada.
        </li>
        <li>
          Você vê o <strong>deslocamento em tempo real</strong> enquanto a
          página está aberta — ícones se movem conforme a máquina trabalha.
        </li>
        <li>
          Use o botão do <strong>trator</strong> no canto do mapa para abrir a
          lista de máquinas e ir ao detalhe de cada uma.
        </li>
      </ul>
      <p>
        <strong>Rastros (até 24 horas):</strong>
      </p>
      <ol>
        <li>
          O período padrão é a <strong>última 1 hora</strong>, já desenhada ao
          abrir o mapa.
        </li>
        <li>
          Clique em <strong>Rastros</strong> para escolher{" "}
          <strong>Última 1 h</strong>, <strong>Últimas 12 h</strong> ou{" "}
          <strong>Últimas 24 h</strong>.
        </li>
        <li>
          O rastro de todas as máquinas e operadores do período aparece no
          mapa. Os ícones continuam no último ponto conhecido.
        </li>
      </ol>
      <p>
        <strong>Rádio — comunicação com a equipe no campo:</strong>
      </p>
      <ul>
        <li>
          O ícone de <strong>rádio</strong> no mapa abre a comunicação por áudio,
          como um HT: segure para falar e solte para enviar.
        </li>
        <li>
          Os áudios enviados pela equipe no app aparecem na janela — você ouve e
          responde direto pelo navegador.
        </li>
        <li>
          O <strong>histórico da conversa</strong> fica visível no painel: quem
          falou, quando e em qual grupo.
        </li>
        <li>
          Para gestão completa dos grupos, use o menu <strong>Rádio</strong> na
          barra lateral.
        </li>
      </ul>
      <p>
        <strong>Rádio via internet — sem limite de distância:</strong>
      </p>
      <ul>
        <li>
          Diferente de um HT comum, o rádio da plataforma funciona pela{" "}
          <strong>internet</strong> — não há limite de alcance entre escritório,
          fazenda e operadores, desde que app e plataforma tenham conexão.
        </li>
        <li>
          Se o operador estiver <strong>sem sinal ou fora da área</strong> no
          momento do envio, a mensagem <strong>não se perde</strong>: fica salva
          e chega assim que o app voltar a ter internet.
        </li>
        <li>
          Todas as mensagens ficam <strong>registradas no histórico</strong> —
          você pode ouvir quantas vezes quiser, na plataforma ou no app.
        </li>
      </ul>
      <p>
        <strong>Resumo:</strong> abra o Painel no início do dia para ver onde
        estão as máquinas, o que está rodando, recuperar rastros das últimas
        horas e falar com o campo sem sair da tela.
      </p>
    </>
  );
}
